import Meta from 'src/components/meta/Meta';

const SignupFormMeta = () => <Meta
  title="Sign Up Now | BrickX"
  description="Join thousands of Australians building toward a home of their own, through the properties chosen by our specialist team."
/>;

export default SignupFormMeta;
